import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { VariantDisplayTypeValues } from "@insite/client-framework/Types/ApiModels";
import ProductAttributes, { ProductAttributesStyles } from "@insite/content-library/Components/ProductAttributes";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges";
import ProductBrand, { ProductBrandStyles } from "@MasterBluePrint/Overrides/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@MasterBluePrint/Overrides/Components/ProductDescription";
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import ProductListVariantSwatch from "@insite/content-library/Widgets/ProductList/ProductListVariantSwatch";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useLaunchDarklyFlags from "@MasterBluePrint/Common/Hooks/useLaunchDarklyFlags";
import { LaunchDarklyFlagKeys } from "@MasterBluePrint/Common/Utilities/LaunchDarklyFlagKeys";
import { isMobileDevice } from "@MasterBluePrint/Overrides/Common/Utilities/isMobileDevice";
import ProductPartNumbers, { ProductPartNumbersStyles }  from "@MasterBluePrint/Overrides/Components/ProductPartNumbers";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";


interface OwnProps {
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showAvailability: boolean;
    showAttributes: boolean;
    showImageBadges?: boolean;
    maxImageBadges?: number;
    showTextBadges?: boolean;
    maxTextBadges?: number;
    showOurPartMfrPartLabels?: boolean;
    showOurPart?: boolean;
    showMfrPart?: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    settingsCollection: getSettingsCollection(state),
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProductContext;

export interface ProductListProductInformationStyles {
    container?: GridContainerProps;
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    brandGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    partNumbersGridItem?: GridItemProps;
    partNumbersStyles?: ProductPartNumbersStyles;
    availabilityGridItem?: GridItemProps;
    availabilityStyles?: ProductAvailabilityStyles;
    attributesGridItem?: GridItemProps;
    attributes?: ProductAttributesStyles;
    searchScoreDataGridItem?: GridItemProps;
    brandStyleNew?: InjectableCss;
    swatchGridItem?: GridItemProps;
    imageBadgeGridItem?: GridItemProps;
    textBadgeGridItem?: GridItemProps;
}

export const productInformationStyles: ProductListProductInformationStyles = {
    container: {
        gap: 10,
        css: css`
            width: 100%;
        `,
    },
    brandStyleNew: {
        css: css`
            color: ${themeColors.colorPrimary};
            width: 100%;
            font-size: ${themeFontSizes.size14};
            font-weight: 500;
            letter-spacing: 0;
            line-height: 1.25rem;
            text-transform: uppercase;
            min-width: 8.125rem;
            @media screen and (min-width: 1400px) {
                max-width: 8.125rem;
            }

            
        `,
    },
    descriptionStyles: {
        productDetailLink: {
            css: css`
                color: ${themeColors.colorPrimary};
                font-size: ${themeFontSizes.size14};
                font-weight: 500;
                letter-spacing: 0;
                text-transform: capitalize;
                display:inline;
                width:fit-content;

                span {                    
                    
                }

                &:hover {
                    text-decoration: underline;
                }

                @media screen and (max-width: 1399px) {
                    color: ${themeColors.colorPrimary};
                    font-family: Roboto, sans-serif;
                    font-size: ${themeFontSizes.size15};
                    font-weight: 500;
                    letter-spacing: 0;
                    margin-bottom: .31250625rem;

                    span {
                        font-size: ${themeFontSizes.size15};
                    }
                }
            `,
            typographyProps: {
                size: 14,
            },
        },
    },
    brandGridItem: {
        width: 12,
        css: css`
           
        `,
    },
    descriptionGridItem: {
        width: 12,
        css: css`
            display:inline-block;
            padding:4px;
            line-height:1.2rem;
        `
    },
    partNumbersGridItem: {
        width: 12,
    },
    availabilityGridItem: {
        width: 12,
    },
    attributesGridItem: {
        width: 12,
    },
    searchScoreDataGridItem: {
        width: 12,
    },
    swatchGridItem: {
        width: 12,
    },
    imageBadgeGridItem: {
        width: 12,
        css: css`
            &.plp-badge {
                div[class*='FlexItem'],
                div[class^='FlexItem'] {
                    width: 100%;
                    max-width: 100%;
                    flex-basis: 100%;
                }
            }
            @media screen and (max-width: 1279px) {
                &.plp-badge {
                    display: none;
                }
            }
        `,
    },
    textBadgeGridItem: {
        width: 12,
    },
    partNumbersStyles: {
        erpNumberLink: {
            css: css``
        },
        manufacturerItemLink: {
            css: css``
        }
    }
};

const styles = productInformationStyles;

const enhancedStyles = {
    descriptionStyles: {
        descriptionMobileStyles: css`
            span {
                    color: #222 !important;
                    font-family: Roboto;
                    font-size: 15px;
                    font-style: normal;
                    font-weight: 400;
                }
        `,
        descriptionDesktopStyles: css`
            span {
                    color: #222 !important;
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                }
        `,
        descriptionDefaultStyles: css`
            span {
                color: ${themeColors.colorPrimary} !important;
            }
        `
    },
    brandStyles: {
        brandMobileStyles: css` 
            span {
                    color: #222 !important;
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;

                    &:hover {
                        text-decoration-line: underline;
                        text-decoration-style: solid;
                        text-decoration-skip-ink: auto;
                        text-decoration-thickness: auto;
                        text-underline-offset: auto;
                        text-underline-position: from-font;
                    }
                }
            `,
        brandDesktopStyles: css`
            span {
                    color: #222 !important;
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;

                    &:hover {
                        text-decoration-line: underline;
                        text-decoration-style: solid;
                        text-decoration-skip-ink: auto;
                        text-decoration-thickness: auto;
                        text-underline-offset: auto;
                        text-underline-position: from-font;
                    }
                }
            `,
        brandDefaultStyles: css``
    },
    erpNumberStyles: {
        erpNumberMobileStyles: css` 
            span {
                    color: #222 !important;
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;

                    &:hover {
                        text-decoration-line: underline;
                        text-decoration-style: solid;
                        text-decoration-skip-ink: auto;
                        text-decoration-thickness: auto;
                        text-underline-offset: auto;
                        text-underline-position: from-font;
                    }
                }
            `,
        erpNumberDesktopStyles: css`
            span {
                    color: #222 !important;
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;

                    &:hover {
                        text-decoration-line: underline;
                        text-decoration-style: solid;
                        text-decoration-skip-ink: auto;
                        text-decoration-thickness: auto;
                        text-underline-offset: auto;
                        text-underline-position: from-font;
                    }
                }
            `,
        erpNumberDefaultStyles: css``
    },
    manufacturerItemStyles: {
        manufacturerItemMobileStyles: css` 
            span {
                    color: #222 !important;
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;

                    &:hover {
                        text-decoration-line: underline;
                        text-decoration-style: solid;
                        text-decoration-skip-ink: auto;
                        text-decoration-thickness: auto;
                        text-underline-offset: auto;
                        text-underline-position: from-font;
                    }
                }
            `,
        manufacturerItemDesktopStyles: css`
            span {
                    color: #222 !important;
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;

                    &:hover {
                        text-decoration-line: underline;
                        text-decoration-style: solid;
                        text-decoration-skip-ink: auto;
                        text-decoration-thickness: auto;
                        text-underline-offset: auto;
                        text-underline-position: from-font;
                    }
                }
            `,
        manufacturerItemDefaultStyles: css``
    }
};

const ProductListProductInformation: FC<Props> = ({
    productContext,
    settingsCollection,
    showBrand,
    showTitle,
    showPartNumbers,
    showAvailability,
    showAttributes,
    showImageBadges,
    maxImageBadges,
    showTextBadges,
    maxTextBadges,
    showOurPartMfrPartLabels = true,
    showOurPart = true,
    showMfrPart = true,
}) => {
    const { product } = productContext;

    if (!product) {
        return null;
    }

    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });
    let variantDisplayTrait = null;
    if (product.variantTraits && product.variantTraits.length > 0) {
        const swatchedViewList = [
            VariantDisplayTypeValues.SwatchDropdown,
            VariantDisplayTypeValues.SwatchList,
            VariantDisplayTypeValues.SwatchGrid,
        ];
        const sortedVaraintTraits = product.variantTraits.slice().sort((a, b) => a.sortOrder - b.sortOrder);
        variantDisplayTrait = sortedVaraintTraits.find(x => swatchedViewList.includes(x.displayType));
    }

    const featureFlags: string[] = [LaunchDarklyFlagKeys.TEUS_8655];
    const flagValues = useLaunchDarklyFlags({ featureFlags });
    const isFeatureOn = flagValues[LaunchDarklyFlagKeys.TEUS_8655];

    const enhancedDescriptionStyles = isFeatureOn
        ? isMobileDevice()
            ? enhancedStyles.descriptionStyles.descriptionMobileStyles
            : enhancedStyles.descriptionStyles.descriptionDesktopStyles
        : enhancedStyles.descriptionStyles.descriptionDefaultStyles

    const descriptionStyles = {
        ...styles.descriptionStyles,
        productDetailLink: {
            ...styles.descriptionStyles?.productDetailLink,
            css: css`
                ${styles.descriptionStyles?.productDetailLink?.css}
                ${enhancedDescriptionStyles}
            `,
        },
    };

    const enhancedBrandStyles = isFeatureOn
        ? isMobileDevice()
            ? enhancedStyles.brandStyles.brandMobileStyles
            : enhancedStyles.brandStyles.brandDesktopStyles
        : enhancedStyles.brandStyles.brandDefaultStyles

    const brandStyles = {
        ...styles.brandStyles,
        nameLink: {
            ...styles.brandStyles?.nameLink,
            css: css`
                ${styles.brandStyles?.nameLink?.css}
                ${enhancedBrandStyles}
            `,
        },
    }

    const enhancedErpNumberStyles = isFeatureOn
        ? isMobileDevice()
            ? enhancedStyles.erpNumberStyles.erpNumberMobileStyles
            : enhancedStyles.erpNumberStyles.erpNumberDesktopStyles
        : enhancedStyles.erpNumberStyles.erpNumberDefaultStyles

    const enhancedManufacturerItemStyles = isFeatureOn
        ? isMobileDevice()
            ? enhancedStyles.manufacturerItemStyles.manufacturerItemMobileStyles
            : enhancedStyles.manufacturerItemStyles.manufacturerItemDesktopStyles
        : enhancedStyles.manufacturerItemStyles.manufacturerItemDefaultStyles

    const partNumbersStyles = {
        ...styles.partNumbersStyles,
        erpNumberLink: {
            ...styles.partNumbersStyles?.erpNumberLink,
            css: css`
                ${styles.partNumbersStyles?.erpNumberLink?.css}
                ${enhancedErpNumberStyles}
            `,
        },
        manufacturerItemLink: {
            ...styles.partNumbersStyles?.manufacturerItemLink,
            css: css`
                ${styles.partNumbersStyles?.manufacturerItemLink?.css}
                ${enhancedManufacturerItemStyles}
            `,
        }
    }

    return (
        <GridContainer {...styles.container}>
            {product.brand && showBrand && (
                <GridItem {...styles.brandGridItem}>
                    <Typography as="span" {...styles.brandStyleNew}>
                        <ProductBrand brand={product.brand} fromPage='productlist' extendedStyles={brandStyles} />
                    </Typography>
                </GridItem>
            )}
            {showTitle && (
                <GridItem {...styles.descriptionGridItem}>
                    <ProductDescription 
                        product={productContext} 
                        extendedStyles={descriptionStyles}
                        carouselType=''
                        carouselTitle=''
                        fromPage="productlist"
                    />
                </GridItem>
            )}
            {showPartNumbers && (
                <GridItem {...styles.partNumbersGridItem}>
                    <ProductPartNumbers
                        productNumber={product.productNumber}
                        customerProductNumber={product.customerProductNumber}
                        manufacturerItem={product.manufacturerItem}
                        extendedStyles={partNumbersStyles}
                        showLabel={showOurPartMfrPartLabels}
                        showOurPart={showOurPart}
                        showMfrPart={showMfrPart}
                        product={productContext}
                        fromPage="productlist"
                    />
                </GridItem>
            )}
            {showTextBadges && textBadges && (
                <GridItem {...styles.textBadgeGridItem}>
                    <ProductTextBadges badgeList={textBadges} maxBadges={maxTextBadges ?? 4} />{" "}
                </GridItem>
            )}
            {showImageBadges && imageBadges && (
                <GridItem {...styles.imageBadgeGridItem} className="plp-badge">
                    <ProductImageBadges badgeList={imageBadges} maxBadges={maxImageBadges ?? 4} />
                </GridItem>
            )}

            {settingsCollection.productSettings.showInventoryAvailability && showAvailability && (
                <GridItem {...styles.availabilityGridItem}>
                    <ProductContextAvailability extendedStyles={styles.availabilityStyles} />
                </GridItem>
            )}
            {showAttributes && (
                <GridItem {...styles.attributesGridItem}>
                    <ProductAttributes maximumNumberAttributeTypes={3} extendedStyles={styles.attributes} />
                </GridItem>
            )}
        </GridContainer>
    );
};

export default connect(mapStateToProps)(withProductContext(ProductListProductInformation));